export function travel(data, path) {
  for (const item of data) {
    if (item.children && item.children.length) {
      const result = travel(item.children, path)
      if (result.length) {
        return [item.title, ...result]
      }
    } else {
      if (item.url && path === item.url.replace('/ui/#', '')) {
        return [item.title]
      }
    }
  }
  return []
}

export function findLeafNode(data, path) {
  for (let i = 0, len = data.length; i < len; i++) {
    const item = data[i]
    if (item.children && item.children.length) {
      const result = findLeafNode(item.children, path)
      if (result) {
        return result
      }
    } else {
      if (item.url && path === item.url.replace('/ui/#', '')) {
        return item.id.toString()
      }
    }
  }
  return ''
}



// WEBPACK FOOTER //
// ./packages/utils/tree.js